import { React, useState } from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import '../css/contractAccountRegistration.css';

const CadastrarCC = () => {
    const [ccAntiga, setCCAntiga] = useState('');
    const [ccNova, setCCNova] = useState('');
    const [instalacao, setInstalacao] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [consorcio, setConsorcio] = useState(true);
    const [documento, setDocumento] = useState('');
    const [notificar, setNotificar] = useState(true);
    const [csv, setCsv] = useState(false);
    const [arquivo, setArquivo] = useState(null);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitCadastrarCC (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            ccAntiga,
            ccNova,
            instalacao,
            documento: consorcio ? '' : documento,
            notificar
        });

        try {
            const response = await fetchFlask('cadastrarCC', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setCCAntiga('');
                setCCNova('');
                setInstalacao('');
                setDocumento('');
            }
        } finally {
            setIsSubmit(false);
        }
    };

    async function submitCadastrarCCBulk (e) {
        e.preventDefault();
        setIsSubmit(true);

        const formData = new FormData();
        formData.append('arquivoCSV', arquivo);

        try {
            const response = await fetchFlask('cadastrarCCBulk', formData);

            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setArquivo(null);
            }
        } finally {
            setIsSubmit(false);
        }
    }

    const operationLabel = consorcio ? 'Entrada no consórcio' : 'Saída do consórcio';
    const fileName = arquivo?.name || '';
    const individualCompletedFields = [
        ccAntiga,
        ccNova,
        consorcio ? instalacao : documento
    ].filter(Boolean).length;
    const csvCompletedFields = [arquivo].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Cadastrar CC
                {csv ? ' - Lote CSV' : ` - ${operationLabel}`}
            </PageHeader>

            {csv && (
                <form action='' method='POST' id='formCadastrarCCCsv' onSubmit={submitCadastrarCCBulk} className='ui-workflow-layout'>
                    <Box className='ui-workflow-workspace'>
                        <Box className='ui-workflow-intro'>
                            <Box>
                                <h2>Alteração em lote por arquivo CSV</h2>
                            </Box>
                            <FormControlLabel
                                className='contract-account-mode-switch'
                                label='CSV'
                                control={
                                    <Switch
                                        checked={csv}
                                        onChange={(e) => setCsv(e.target.checked)}
                                    />
                                }
                            />
                        </Box>

                        <Box className='ui-workflow-panel'>
                            <Box className='ui-heading'>
                                <FileUploadRoundedIcon />
                                <Box>
                                    <span>Etapa única</span>
                                    <strong>Arquivo de contas contrato</strong>
                                </Box>
                            </Box>

                            <Box className='contract-account-upload-strip'>
                                <Inventory2RoundedIcon />
                                <Box>
                                    <span>Formato esperado</span>
                                    <strong>CC Antiga;CC Nova;Instalação</strong>
                                </Box>
                                <TextField
                                    required
                                    type='file'
                                    size='small'
                                    inputProps={{ accept: 'text/csv' }}
                                    onChange={(e) => setArquivo(e.target.files[0])}
                                />
                            </Box>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary'>
                        <Box className='ui-heading ui-heading-divided'>
                            <FactCheckRoundedIcon />
                            <Box>
                                <span>Resumo</span>
                                <strong>Revisão do lote</strong>
                            </Box>
                        </Box>

                        <Box className='ui-workflow-summary-list'>
                            <Box>
                                <span>Modo</span>
                                <strong>CSV</strong>
                            </Box>
                            <Box>
                                <span>Arquivo</span>
                                <strong className={!fileName ? 'is-empty' : undefined}>{fileName || 'Não selecionado'}</strong>
                            </Box>
                            <Box>
                                <span>Layout</span>
                                <strong>CC Antiga;CC Nova;Instalação</strong>
                            </Box>
                        </Box>

                        <Box className='ui-attention'>
                            <RuleRoundedIcon />
                            <p>Confirme se o arquivo segue o formato indicado antes de iniciar a alteração em lote.</p>
                        </Box>

                        <Box className='ui-attention is-ok ui-completion'>
                            <AssignmentTurnedInRoundedIcon />
                            <Box>
                                <span>Campos críticos</span>
                                <strong>{csvCompletedFields}/1 preenchido</strong>
                            </Box>
                        </Box>

                        <SubmitButton isSubmit={isSubmit} startIcon={<PlaylistAddRoundedIcon />}>
                            Alterar CCs
                        </SubmitButton>
                    </Box>
                </form>
            )}

            {!csv && (
                <form action='' method='POST' id='formCadastrarCC' onSubmit={submitCadastrarCC} className='ui-workflow-layout'>
                    <Box className='ui-workflow-workspace'>
                        <Box className='ui-workflow-intro'>
                            <Box>
                                <h2>Alteração individual de conta contrato</h2>
                            </Box>
                            <FormControlLabel
                                className='contract-account-mode-switch'
                                label='CSV'
                                control={
                                    <Switch
                                        checked={csv}
                                        onChange={(e) => setCsv(e.target.checked)}
                                    />
                                }
                            />
                        </Box>

                        <Box className='ui-workflow-panel'>
                            <Box className='ui-heading'>
                                <GroupsRoundedIcon />
                                <Box>
                                    <span>Etapa 1</span>
                                    <strong>Tipo de movimentação</strong>
                                </Box>
                            </Box>

                            <Box className='contract-account-operation-strip'>
                                <SwapHorizRoundedIcon />
                                <FormControlLabel
                                    label={consorcio ? 'Entrada' : 'Saída'}
                                    control={
                                        <Switch
                                            checked={consorcio}
                                            onChange={(e) => setConsorcio(e.target.checked)}
                                        />
                                    }
                                />
                                <span>{operationLabel}</span>
                            </Box>
                        </Box>

                        <Box className='ui-workflow-panel'>
                            <Box className='ui-heading'>
                                <Inventory2RoundedIcon />
                                <Box>
                                    <span>Etapa 2</span>
                                    <strong>Contas contrato</strong>
                                </Box>
                            </Box>

                            <Box className='contract-account-field-grid'>
                                <TextField
                                    required
                                    label='Conta Contrato Antiga'
                                    value={ccAntiga}
                                    onChange={(e) => setCCAntiga(e.target.value)}
                                />
                                <TextField
                                    required
                                    label='Conta Contrato Nova'
                                    value={ccNova}
                                    onChange={(e) => setCCNova(e.target.value)}
                                />
                            </Box>
                        </Box>

                        <Box className='ui-workflow-panel'>
                            <Box className='ui-heading'>
                                <RuleRoundedIcon />
                                <Box>
                                    <span>Etapa 3</span>
                                    <strong>{consorcio ? 'Dados da instalação' : 'Dados de saída'}</strong>
                                </Box>
                            </Box>

                            {consorcio && (
                                <Box className='contract-account-single-field'>
                                    <TextField
                                        required
                                        label='Instalação'
                                        value={instalacao}
                                        onChange={(e) => setInstalacao(e.target.value)}
                                    />
                                </Box>
                            )}

                            {!consorcio && (
                                <Box className='contract-account-exit-grid'>
                                    <TextField
                                        required
                                        label='Documento'
                                        value={documento}
                                        onChange={(e) => setDocumento(e.target.value)}
                                    />
                                    <FormControl className='contract-account-notify-control'>
                                        <FormControlLabel
                                            label='Notificar cliente'
                                            control={<Checkbox
                                                checked={notificar}
                                                onChange={() => setNotificar(!notificar)}
                                            />}
                                        />
                                    </FormControl>
                                </Box>
                            )}
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary'>
                        <Box className='ui-heading ui-heading-divided'>
                            <FactCheckRoundedIcon />
                            <Box>
                                <span>Resumo</span>
                                <strong>Revisão da alteração</strong>
                            </Box>
                        </Box>

                        <Box className='ui-workflow-summary-list'>
                            <Box>
                                <span>Movimentação</span>
                                <strong>{operationLabel}</strong>
                            </Box>
                            <Box>
                                <span>CC antiga</span>
                                <strong className={!ccAntiga ? 'is-empty' : undefined}>{ccAntiga || 'Não informada'}</strong>
                            </Box>
                            <Box>
                                <span>CC nova</span>
                                <strong className={!ccNova ? 'is-empty' : undefined}>{ccNova || 'Não informada'}</strong>
                            </Box>
                            <Box>
                                <span>{consorcio ? 'Instalação' : 'Documento'}</span>
                                <strong className={!(consorcio ? instalacao : documento) ? 'is-empty' : undefined}>
                                    {(consorcio ? instalacao : documento) || 'Não informado'}
                                </strong>
                            </Box>
                            {!consorcio && (
                                <Box>
                                    <span>Notificação</span>
                                    <strong>{notificar ? 'Cliente será notificado' : 'Sem notificação ao cliente'}</strong>
                                </Box>
                            )}
                        </Box>

                        <Box className='ui-attention'>
                            {consorcio ? <GroupsRoundedIcon /> : <NotificationsActiveRoundedIcon />}
                            <p>Revise os dados antes de alterar a conta contrato. A operação seguirá o fluxo selecionado.</p>
                        </Box>

                        <Box className='ui-attention is-ok ui-completion'>
                            <AssignmentTurnedInRoundedIcon />
                            <Box>
                                <span>Campos críticos</span>
                                <strong>{individualCompletedFields}/3 preenchidos</strong>
                            </Box>
                        </Box>

                        <SubmitButton isSubmit={isSubmit} startIcon={<PlaylistAddRoundedIcon />}>
                            Alterar CC
                        </SubmitButton>
                    </Box>
                </form>
            )}
        </Box>
    );
};

export default CadastrarCC;
